import { Reveal, GoldButton, GhostButton } from "./Reveal";

export const CtaStrip = ({ onQuiz, onCounselling, title, testId }) => (
  <section className="px-4 sm:px-8 lg:px-16" data-testid={testId}>
    <Reveal>
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-3xl border border-gold/25 bg-gradient-to-br from-elevated via-surface to-void px-8 py-14 sm:px-14 sm:py-16 spotlight">
        <div className="pointer-events-none absolute -right-20 -top-24 h-72 w-72 rounded-full bg-gold/10 blur-[100px]" />
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-gold/90">Not sure where to start?</p>
        <h2 className="mt-4 max-w-2xl font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-tight text-neutral-100">
          {title || (
            <>Take the free 5-minute assessment — <em className="text-gold-gradient not-italic">or just talk to a mentor.</em></>
          )}
        </h2>
        <div className="mt-9 flex flex-wrap gap-4">
          <GoldButton testId={`${testId}-quiz-button`} onClick={onQuiz}>Free Career Assessment</GoldButton>
          <GhostButton testId={`${testId}-counselling-button`} onClick={onCounselling}>Talk to a Mentor — Free</GhostButton>
        </div>
      </div>
    </Reveal>
  </section>
);
